<script setup>
import SecondaryButton from '@/Components/Button/SecondaryButton.vue';
import { usePage } from '@inertiajs/vue3';
import { captureSignupClicked } from '@/Common/Posthog.js';

const { branding } = usePage().props;

const redirect = () => {
  captureSignupClicked();
  window.open(branding.signup.href, '_blank', 'noopener,noreferrer');
};
</script>

<template>
  <SecondaryButton v-if="branding?.signup?.href" size="large" @click="redirect">
    {{ branding.signup.title }}
  </SecondaryButton>
</template>
